import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      // Show button when page is scrolled down 500px
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  return <AnimatePresence data-id="element-92">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 50
    }} className="fixed bottom-6 left-0 right-0 z-50 px-6 md:hidden flex justify-center pointer-events-none" data-id="element-93">
          <a href="#diagnostico" className="pointer-events-auto w-full max-w-sm bg-gold text-navy font-bold text-center py-4 rounded-full shadow-[0_10px_25px_rgba(13,27,42,0.5)] border-2 border-white/20 flex items-center justify-center gap-2" data-id="element-94">
            COMENZAR AHORA <span className="text-xl leading-none" data-id="element-95">→</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}